import Marquee from "react-fast-marquee";
import { useMemo } from "react";

/**
 * Bold infinite-marquee strip used between sections.
 * `items` can be an array OR a newline/comma-separated string (CMS-friendly).
 */
export default function MarqueeStrip({ items, dark = true, speed = 38 }) {
  const tone = dark ? "bg-emerald-ink text-bone" : "bg-bone text-emerald";
  const accent = dark ? "text-neon" : "text-bronze";

  const list = useMemo(() => {
    if (Array.isArray(items)) return items.filter(Boolean);
    if (typeof items !== "string") return [];
    return items
      .split(/[\n,]+/)
      .map((s) => s.trim())
      .filter(Boolean);
  }, [items]);

  if (list.length === 0) return null;

  return (
    <div className={`${tone} py-6 sm:py-8 border-y border-current/5 overflow-hidden relative`} aria-hidden="true">
      <Marquee speed={speed} gradient={false} pauseOnHover>
        <div className="marquee-text font-display text-3xl sm:text-5xl md:text-6xl tracking-tight pr-10 sm:pr-16">
          {list.map((it, i) => (
            <span key={i} className="inline-flex items-center gap-6 sm:gap-12">
              <span className="opacity-90">{it}</span>
              <span className={`${accent} text-xl sm:text-2xl leading-none`}>✦</span>
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
